import React from 'react';
import classNames from 'classnames';
export const MapCircleButton = ({ icon, className, active, style, onClick, }) => {
    return (React.createElement("button", { className: classNames(className, `circle-button`, {
            enabled: active,
        }), "aria-label": `Map 2d/3d switcher`, style: style, tabIndex: -1, onClick: onClick }, icon));
};
//# sourceMappingURL=MapCircleButton.js.map